module.exports = __webpack_public_path__ + "media/images/showreel.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/showreel.gif
// module id = 150
// module chunks = 0